import { AfterViewInit, Component } from '@angular/core';
import { UtilidadesService } from '../../utilidades.servicios.index';

import { environment } from '../../../../environments/environment';
import { Router, ActivationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { GlobalService } from '../../../Servicios/global.service';
import { FiltroProductosModel } from '../../../Modelo/Filtro_Productos.model';
import { CarritoDeComprasService } from '../../../Servicios/carrito-de-compras.service';
import { MultiCheckboxModel } from 'src/app/Modelo/multiCheckboxModel';
import { CategoriaPrincipalModel } from 'src/app/Modelo/CategoriaPrincipal.model';
import { AppConstants } from 'src/app/app.constants';

@Component({
	selector: 'navbar-app',
	templateUrl: 'navbar.component.html',
	styleUrls: ['navbar.component.scss']
})
export class NavbarComponent implements AfterViewInit {
	public FotoDePerfil: any;
	public Usuario: any;
	public Entorno: any = environment;
	public openMenu = false;
	public isProductUrl = false;
	public showSearchMobile = false;

	constructor(
		public Utilidades: UtilidadesService,
		private _router: Router,
		public Global: GlobalService,
		public CarritoDeCompras: CarritoDeComprasService
	) {
		this.ObtenerDatosDeRuta().subscribe(e => {
			this.Utilidades._titulo = e.Titulo;
			this.isProductUrl = this._router.routerState.snapshot.url.includes('/Productos')   ? true : false;
		});
	}

	getUrlForMainCategoryProductsSearch(mainCategoryId: number): string {
		return `/Productos/${AppConstants.mainCategoryPathRoute}/${mainCategoryId}`;
	}

	ngAfterViewInit(): void {
	}

	private ObtenerDatosDeRuta() {
		return this._router.events
			.pipe(
				//Tengo que filtrar los eventos del router. Sólo necesito el evento
				//que es de tipo ActivationEnd
				filter(evento => evento instanceof ActivationEnd),

				//Transformo la salida para sólo devolver el dato que necesito
				map((evento: ActivationEnd) => evento.snapshot.data)
			);
	}

	public BuscarProducto(): void {
		if ((this.Global.FiltroProductos.textFilterCategories?.length ?? 0) === 0) {
			this.Global.FiltroProductos.loadTextFilterCategories(this.Global.FiltroProductos.TextFilterCategoryDescription);
		}
		else if (this.Global.FiltroProductos.textFilterCategories.every(t => !t.checked)) {
			this.Global.FiltroProductos.textFilterCategories.forEach((currentTextFilter: MultiCheckboxModel<number>) => {
				if (currentTextFilter.key === this.Global.FiltroProductos.TextFilterCategoryDescription)
					currentTextFilter.checked = true;
			});
		}
		
		this.Utilidades.Navegar(["/Productos", encodeURI(this.Global.FiltroProductos.TextoABuscar)]);
	}

	public menuStatus(ev: boolean): void {
		this.openMenu = ev;
	}

	get logoUrl(): string {
		return 'assets/images/logo-color.png';
	  }
}